import { Box, CircularProgress } from "@mui/material";
import { KeyDriveTabPanel } from "../../../../components/KeydriveComponents/Tabs/components/KeyDriveTabPanel";
import { KeyDriveSearchBarWithButton } from "../../../../components/KeydriveComponents/SearchBars/KeyDriveSearchBarWithButton";
import { KeyDriveTable } from "../../../../components/KeydriveComponents/Tables/KeyDriveTable";
import { UserPermission } from "../../../../model/UserModel";
import UserRowDefault from "../../../../components/KeydriveComponents/Tables/Rows/UserRowDefault";
import { StatePrivilegesTypes } from "../WorkSpacePermissions";
import { useTranslation } from "react-i18next";
import { EmptyContainer } from "../../../../components/KeydriveComponents/EmptyContainer/EmptyContainer";
import { HowToReg } from "@mui/icons-material";
import { PermissionTargetType } from "../../../../enums/PermissionTargetType";

interface IPrivilegesKeydriveTabOne {
    targetType: PermissionTargetType;
    loadingUsers: boolean;
    setSearchFilter: (set: string) => void;
    allUsersMemory: UserPermission[];
    tableUserHeaders: string[];
    setPrivilegesState?: (set: { state: StatePrivilegesTypes, id: string, permissionType: number }) => void;
    ownerId: string;
    hasFolderChild: boolean;
}

function PrivilegesKeydriveTabOne({
    allUsersMemory,
    loadingUsers,
    setSearchFilter,
    tableUserHeaders,
    targetType,
    setPrivilegesState,
    ownerId,
    hasFolderChild
}: IPrivilegesKeydriveTabOne) {

  const { t } = useTranslation();

    return (
        <KeyDriveTabPanel
          index={0}
          value={targetType == PermissionTargetType.User ? 0 : 1}
        >
          { loadingUsers ? (
            <CircularProgress variant='indeterminate' />
          ) : (
            <>
              <Box
                mb="12px"
              >
                <KeyDriveSearchBarWithButton 
                  btnText={t("Privileges.DefinePrivilege")}
                  onClick={() => { setPrivilegesState!({ state: "adding user", id: "", permissionType: -1 }) }}
                  onChange={(e) => setSearchFilter(e.currentTarget.value)}
                />
              </Box>
              {allUsersMemory.length > 0 && <KeyDriveTable
                headers={tableUserHeaders}
                body={
                    allUsersMemory?.map(user => (
                            <UserRowDefault
                              loading={loadingUsers}
                              user={user}
                              setPrivilegesState={setPrivilegesState}
                              ownerId={ownerId}
                              hasFolderChild={hasFolderChild}
                              key={user.userId}
                            />
                        ))
                }
                needFooter={false}
              />}
              {(allUsersMemory.length == 0) &&
                      <Box mt="20px" height="calc(100vh - 400px)">
                        <EmptyContainer
                          icon={<HowToReg fontSize='large' sx={{color: "#22638D"}}/>}
                          title={t("Privileges.NoPrivileges")}
                          content={t("Privileges.NoPrivilegesText")} />
                      </Box>
                    }
            </>
          ) }
        </KeyDriveTabPanel>
    );
}

export default PrivilegesKeydriveTabOne;